import { NgModule, ModuleWithProviders, SkipSelf, Optional } from '@angular/core';
import { Configuration } from './configuration';
import { HttpClient } from '@angular/common/http';


import { LandOwnerAuthService } from './api/landOwnerAuth.service';
import { LandOwnerCommercialDocumentsService } from './api/landOwnerCommercialDocuments.service';
import { LandOwnerContractsService } from './api/landOwnerContracts.service';
import { LandOwnerDetailsService } from './api/landOwnerDetails.service';
import { LandOwnerPerformanceService } from './api/landOwnerPerformance.service';
import { LandOwnerPropertyService } from './api/landOwnerProperty.service';
import { LandOwnerReservationsService } from './api/landOwnerReservations.service';
import { LandOwnerSalesChannelsService } from './api/landOwnerSalesChannels.service';
import { LandOwnerUsersService } from './api/landOwnerUsers.service';

@NgModule({
  imports:      [],
  declarations: [],
  exports:      [],
  providers: []
})
export class ApiModule {
    public static forRoot(configurationFactory: () => Configuration): ModuleWithProviders<ApiModule> {
        return {
            ngModule: ApiModule,
            providers: [ { provide: Configuration, useFactory: configurationFactory } ]
        };
    }

    constructor( @Optional() @SkipSelf() parentModule: ApiModule,
                 @Optional() http: HttpClient) {
        if (parentModule) {
            throw new Error('ApiModule is already loaded. Import in your base AppModule only.');
        }
        if (!http) {
            throw new Error('You need to import the HttpClientModule in your AppModule! \n' +
            'See also https://github.com/angular/angular/issues/20575');
        }
    }
}
